import { render } from "./dangjInfo.vue?vue&type=template&id=127d7cb4&scoped=true"
import script from "./dangjInfo.vue?vue&type=script&lang=js"
export * from "./dangjInfo.vue?vue&type=script&lang=js"

import "./dangjInfo.vue?vue&type=style&index=0&id=127d7cb4&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d7cb4"]])

export default __exports__